<template>
  <p>
    V&iacute;tejte v z&aacute;sad&aacute;ch ochrany osobn&iacute;ch &uacute;dajů společnosti Draph
    Solutions S.r.o.
  </p>
  <p>
    Draph Solutions S.r.o. je společnost registrovan&aacute; v Česk&eacute; republice
    (&bdquo;CZ&ldquo;) s identifikačn&iacute;m č&iacute;slem C 278807, se s&iacute;dlem na adrese
    Národní 961/25, Staré Město, 110 00 Praha 1 (d&aacute;le jen &bdquo;Draph&ldquo;,
    &bdquo;my&ldquo; nebo &bdquo;n&aacute;s&ldquo;).
  </p>

  <p>Poskytujeme na&scaron;e služby pod obchodn&iacute;m n&aacute;zvem &bdquo;Swipez&ldquo;.</p>

  <p>
    Nab&iacute;z&iacute;me platebn&iacute; služby jako poskytovatel platebn&iacute;ch služeb
    mal&eacute;ho rozsahu (&bdquo;SSP&ldquo;). Jsme opr&aacute;vněni a regulov&aacute;ni Českou
    n&aacute;rodn&iacute; bankou (&bdquo;ČNB&ldquo;).
  </p>
  <p>
    Na&scaron;e obchodn&iacute; činnost, poskytov&aacute;n&iacute; služeb a vztahy s klienty i ČNB
    se ř&iacute;d&iacute; platn&yacute;mi z&aacute;kony Česk&eacute; republiky.
  </p>
  <p>
    Je pro n&aacute;s nesm&iacute;rně důležit&eacute;, abyste si pečlivě přečetli n&iacute;že
    uveden&eacute; informace a plně porozuměli tomu, jak použ&iacute;v&aacute;me a
    chr&aacute;n&iacute;me va&scaron;e osobn&iacute; &uacute;daje.
  </p>
  <p>OCHRANA VA&Scaron;ICH OSOBN&Iacute;CH &Uacute;DAJŮ</p>

  <p>
    Zavazujeme se k ochraně va&scaron;ich osobn&iacute;ch &uacute;dajů a jejich bezpečn&eacute;mu
    uchov&aacute;v&aacute;n&iacute;. Va&scaron;e osobn&iacute; &uacute;daje
    zpracov&aacute;v&aacute;me v souladu s na&scaron;imi z&aacute;konn&yacute;mi povinnostmi
    stanoven&yacute;mi:
  </p>

  <p>
    &nbsp;&nbsp;&nbsp; Z&aacute;konem o zpracov&aacute;n&iacute; osobn&iacute;ch &uacute;dajů 2019
    (č. 110/2019 Sb., &bdquo;ZZO&Uacute;&ldquo;), d&aacute;le jen &bdquo;Z&aacute;kon&ldquo;,
  </p>
  <p>
    &nbsp;&nbsp;&nbsp; Nař&iacute;zen&iacute;m (EU) 2016/679 Evropsk&eacute;ho parlamentu a Rady ze
    dne 27. dubna 2016 o ochraně fyzick&yacute;ch osob v souvislosti se zpracov&aacute;n&iacute;m
    osobn&iacute;ch &uacute;dajů a o voln&eacute;m pohybu těchto &uacute;dajů, kter&yacute;m se
    zru&scaron;uje směrnice 95/46/ES (Obecn&eacute; nař&iacute;zen&iacute; o ochraně osobn&iacute;ch
    &uacute;dajů, d&aacute;le jen &bdquo;GDPR&ldquo;),
  </p>
  <p>&nbsp;&nbsp;&nbsp; uzn&aacute;van&yacute;mi normami a osvědčen&yacute;mi postupy.</p>

  <p>
    Tyto z&aacute;sady ochrany osobn&iacute;ch &uacute;dajů se vztahuj&iacute; na
    n&aacute;v&scaron;těvn&iacute;ky na&scaron;ich webov&yacute;ch str&aacute;nek,
    st&aacute;vaj&iacute;c&iacute; i potenci&aacute;ln&iacute; klienty, kteř&iacute;
    využ&iacute;vaj&iacute; nebo hodlaj&iacute; využ&iacute;vat na&scaron;e služby.
  </p>

  <p>
    Na&scaron;e z&aacute;sady ochrany osobn&iacute;ch &uacute;dajů podrobně popisuj&iacute;
    &uacute;čely, pro kter&eacute; zpracov&aacute;v&aacute;me va&scaron;e osobn&iacute;
    &uacute;daje, s k&yacute;m je sd&iacute;l&iacute;me, jak&aacute; m&aacute;te v souvislosti s
    nimi pr&aacute;va a v&scaron;echny dal&scaron;&iacute; důležit&eacute; informace, kter&eacute;
    byste měli zn&aacute;t.
  </p>
  <p><strong>JAK SHROMAŽĎUJEME VA&Scaron;E OSOBN&Iacute; &Uacute;DAJE</strong></p>
  <p>
    Použ&iacute;v&aacute;me různ&eacute; metody ke shromažďov&aacute;n&iacute; &uacute;dajů o
    v&aacute;s, včetně:
  </p>
  <ul>
    <li>
      <strong>Př&iacute;m&eacute; interakce:</strong> Osobn&iacute; &uacute;daje n&aacute;m
      poskytujete sami. To zahrnuje situace, kdy:
    </li>
    <ul>
      <li>
        ž&aacute;d&aacute;te o na&scaron;e služby nebo je použ&iacute;v&aacute;te
        prostřednictv&iacute;m webu nebo aplikace,
      </li>
      <li>
        se registrujete v na&scaron;em syst&eacute;mu na webu, vyplňujete formul&aacute;ře a
        dotazn&iacute;ky,
      </li>
      <li>se přihla&scaron;ujete k odběru newsletteru,</li>
      <li>
        ž&aacute;d&aacute;te o zas&iacute;l&aacute;n&iacute; marketingov&yacute;ch informac&iacute;,
      </li>
      <li>pod&aacute;v&aacute;te st&iacute;žnost,</li>
      <li>se &uacute;častn&iacute;te soutěže, propagačn&iacute; akce nebo průzkumu,</li>
      <li>n&aacute;m poskytujete zpětnou vazbu nebo n&aacute;s kontaktujete.</li>
    </ul>
    <li>
      <strong>Automatizovan&eacute; technologie nebo interakce:</strong> Při
      použ&iacute;v&aacute;n&iacute; na&scaron;eho syst&eacute;mu, webu nebo aplikace automaticky
      shromažďujeme technick&aacute; data o va&scaron;em zař&iacute;zen&iacute;, pohybu po webu a
      vzorc&iacute;ch chov&aacute;n&iacute;. Tyto &uacute;daje z&iacute;sk&aacute;v&aacute;me
      prostřednictv&iacute;m souborů cookies, serverov&yacute;ch logů a jin&yacute;ch
      podobn&yacute;ch technologi&iacute;.
    </li>
    <li>
      <strong>Třet&iacute; strany nebo veřejn&eacute; zdroje:</strong> Osobn&iacute; &uacute;daje o
      v&aacute;s můžeme z&iacute;skat od různ&yacute;ch třet&iacute;ch stran nebo veřejn&yacute;ch
      zdrojů.
    </li>
  </ul>
  <p><strong>TYPY OSOBN&Iacute;CH &Uacute;DAJŮ, KTER&Eacute; SHROMAŽĎUJEME</strong></p>
  <p>
    Osobn&iacute; &uacute;daje znamenaj&iacute; jak&eacute;koli informace o jednotlivci, na
    z&aacute;kladě kter&yacute;ch lze tuto osobu identifikovat.
  </p>
  <p>
    Můžeme shromažďovat, použ&iacute;vat, ukl&aacute;dat a před&aacute;vat různ&eacute; typy
    osobn&iacute;ch &uacute;dajů na z&aacute;kladě n&aacute;sleduj&iacute;c&iacute;ch
    pr&aacute;vn&iacute;ch důvodů pro zpracov&aacute;n&iacute;:
  </p>
  <ul>
    <li>
      <strong>Kontaktn&iacute; &uacute;daje:</strong> adresa, e-mailov&aacute; adresa,
      telefonn&iacute; č&iacute;slo, soci&aacute;ln&iacute; s&iacute;tě,
    </li>
    <li>
      <strong>Identifikačn&iacute; &uacute;daje:</strong> jm&eacute;no,
      dř&iacute;věj&scaron;&iacute; jm&eacute;no, př&iacute;jmen&iacute;, uživatelsk&eacute;
      jm&eacute;no nebo podobn&yacute; identifik&aacute;tor, rodinn&yacute; stav, titul, datum
      narozen&iacute;, č&iacute;slo občansk&eacute;ho průkazu, n&aacute;rodnost,
      st&aacute;tn&iacute; př&iacute;slu&scaron;nost, m&iacute;sto narozen&iacute;, daňov&eacute;
      identifikačn&iacute; č&iacute;slo, role/pozice,
    </li>
    <li>
      <strong>Marketingov&eacute; a komunikačn&iacute; &uacute;daje:</strong> preference
      t&yacute;kaj&iacute;c&iacute; se zas&iacute;l&aacute;n&iacute; marketingov&yacute;ch
      informac&iacute; od n&aacute;s a třet&iacute;ch stran, preference v komunikaci,
    </li>
    <li>
      <strong>Technick&aacute; data:</strong> IP adresa, přihla&scaron;ovac&iacute; &uacute;daje,
      typ a verze prohl&iacute;žeče, zař&iacute;zen&iacute;, nastaven&iacute; časov&eacute;ho
      p&aacute;sma a poloha, typy a verze z&aacute;suvn&yacute;ch modulů prohl&iacute;žeče,
      operačn&iacute; syst&eacute;m a platforma a dal&scaron;&iacute; technologie
      použ&iacute;van&eacute; k př&iacute;stupu na n&aacute;&scaron; web, syst&eacute;m nebo
      aplikaci,
    </li>
    <li>
      <strong>&Uacute;daje o už&iacute;v&aacute;n&iacute;:</strong> informace o tom, jak
      použ&iacute;v&aacute;te na&scaron;e služby, web, syst&eacute;m nebo aplikaci,
    </li>
    <li>
      <strong>Bezpečnostn&iacute; &uacute;daje:</strong> při registraci k na&scaron;im
      služb&aacute;m a &uacute;čtu můžete b&yacute;t pož&aacute;d&aacute;ni o odpovědi na
      bezpečnostn&iacute; ot&aacute;zky, vytvořen&iacute; hesla,
    </li>
    <li>
      <strong>Platebn&iacute; &uacute;daje:</strong> pro prov&aacute;děn&iacute; nebo
      přij&iacute;m&aacute;n&iacute; plateb shromažďujeme &uacute;daje o va&scaron;em
      bankovn&iacute;m/platebn&iacute;m &uacute;čtu, např&iacute;klad k&oacute;d banky, č&iacute;slo
      &uacute;čtu, IBAN a/nebo Swift k&oacute;d,
    </li>
    <li>
      <strong>KYC &uacute;daje (ověřen&iacute; identity):</strong> pokud potřebujeme ověřit
      va&scaron;i identitu, pož&aacute;d&aacute;me v&aacute;s o poskytnut&iacute; někter&eacute;ho z
      n&aacute;sleduj&iacute;c&iacute;ch &uacute;dajů:
    </li>
    <ul>
      <li>Kontaktn&iacute; &uacute;daje,</li>
      <li>Identifikačn&iacute; &uacute;daje,</li>
      <li>Platebn&iacute; &uacute;daje,</li>
      <li>Kopie identifikačn&iacute;ho dokladu (pas nebo občansk&yacute; průkaz),</li>
      <li>Kontrola živosti nebo selfie s identifikačn&iacute;m dokladem,</li>
      <li>Důkaz o adrese (např. faktura za služby nebo v&yacute;pis z &uacute;čtu),</li>
      <li>Prohl&aacute;&scaron;en&iacute; PEP (politicky exponovan&aacute; osoba),</li>
      <li>
        Dokumenty prokazuj&iacute;c&iacute; v&aacute;&scaron; př&iacute;jem,
        zaměstn&aacute;n&iacute;, typ podnik&aacute;n&iacute;.
      </li>
    </ul>
    <li>
      <strong
        >&Uacute;daje o prověřov&aacute;n&iacute; a monitorov&aacute;n&iacute;
        transakc&iacute;:</strong
      >
      informace o transakc&iacute;ch, jako je jm&eacute;no klienta, ID transakce, stav, &uacute;daje
      o odes&iacute;lateli nebo př&iacute;jemci, možn&eacute; shody se sankčn&iacute;mi seznamy a
      dal&scaron;&iacute; relevantn&iacute; informace, v&yacute;sledky kontrol podezřel&yacute;ch
      transakc&iacute;,
    </li>
    <li>
      <strong>&Uacute;daje pro due diligence (DD):</strong> informace ověřuj&iacute;c&iacute; zdroj
      va&scaron;ich finančn&iacute;ch prostředků nebo majetku, prov&aacute;děn&iacute; kontroly due
      diligence,
    </li>
    <li>
      <strong>Dobrovoln&eacute; &uacute;daje:</strong> informace, kter&eacute; n&aacute;m dobrovolně
      poskytnete, např&iacute;klad při komunikaci s n&aacute;mi (telefonicky, e-mailem,
      po&scaron;tou nebo na soci&aacute;ln&iacute;ch s&iacute;t&iacute;ch) nebo při &uacute;časti na
      soutěž&iacute;ch, propagačn&iacute;ch akc&iacute;ch či průzkumech.
    </li>
  </ul>
  <p><strong>&Uacute;ČELY POUŽIT&Iacute; VA&Scaron;ICH OSOBN&Iacute;CH &Uacute;DAJŮ</strong></p>
  <p>
    Va&scaron;e osobn&iacute; &uacute;daje budeme použ&iacute;vat pouze v př&iacute;padech, kdy
    n&aacute;m to z&aacute;kon umožňuje.
  </p>
  <p>
    Nejčastěji budeme va&scaron;e osobn&iacute; &uacute;daje použ&iacute;vat v
    n&aacute;sleduj&iacute;c&iacute;ch situac&iacute;ch:
  </p>
  <ul>
    <li>
      Při nav&aacute;z&aacute;n&iacute; obchodn&iacute;ho vztahu a otevřen&iacute; &uacute;čtu pro
      poskytov&aacute;n&iacute; na&scaron;ich služeb,
    </li>
    <li>
      Pokud je to nezbytn&eacute; pro na&scaron;e opr&aacute;vněn&eacute; z&aacute;jmy (nebo
      opr&aacute;vněn&eacute; z&aacute;jmy třet&iacute; strany) a va&scaron;e z&aacute;jmy a
      z&aacute;kladn&iacute; pr&aacute;va tyto z&aacute;jmy nepřev&aacute;ž&iacute;,
    </li>
    <li>Pokud mus&iacute;me splnit regulačn&iacute; povinnost,</li>
    <li>Pokud mus&iacute;me splnit smluvn&iacute; povinnost.</li>
  </ul>
  <p><strong>ZVL&Aacute;&Scaron;TN&Iacute; KATEGORIE OSOBN&Iacute;CH &Uacute;DAJŮ</strong></p>
  <p>
    Někter&eacute; typy osobn&iacute;ch &uacute;dajů jsou podle platn&yacute;ch z&aacute;konů o
    ochraně &uacute;dajů označeny jako zvl&aacute;&scaron;tn&iacute; kategorie osobn&iacute;ch
    &uacute;dajů nebo citliv&eacute; &uacute;daje. To znamen&aacute;, že se jedn&aacute; o
    citlivěj&scaron;&iacute; typy osobn&iacute;ch &uacute;dajů, a proto mus&iacute;me přijmout
    dal&scaron;&iacute; opatřen&iacute; k jejich ochraně. Patř&iacute; sem informace o
    va&scaron;&iacute; rase nebo etnick&eacute;m původu, n&aacute;božensk&eacute;m nebo
    filozofick&eacute;m přesvědčen&iacute;, sexu&aacute;ln&iacute;m životě, sexu&aacute;ln&iacute;
    orientaci, politick&yacute;ch n&aacute;zorech, členstv&iacute; v odborech, zdravotn&iacute;m
    stavu a genetick&yacute;ch a biometrick&yacute;ch &uacute;daj&iacute;ch.
  </p>
  <p>
    Pokud zpracov&aacute;v&aacute;me <strong>platebn&iacute; &uacute;daje</strong>, kter&eacute;
    mohou obsahovat zvl&aacute;&scaron;tn&iacute; kategorie osobn&iacute;ch &uacute;dajů nebo
    osobn&iacute; &uacute;daje t&yacute;kaj&iacute;c&iacute; se trestn&yacute;ch činů a deliktů,
    zaji&scaron;ťujeme, že:
  </p>
  <ul>
    <li>
      se uplatňuje jedna z v&yacute;jimek uveden&yacute;ch v
      <strong>čl&aacute;nku 9 (2) GDPR</strong>, tj. zpracov&aacute;n&iacute; je nezbytn&eacute; z
      důvodu v&yacute;znamn&eacute;ho veřejn&eacute;ho z&aacute;jmu, a/nebo
    </li>
    <li>jsou splněny podm&iacute;nky <strong>čl&aacute;nku 10 GDPR</strong>.</li>
  </ul>
  <p><strong>SD&Iacute;LEN&Iacute; VA&Scaron;ICH OSOBN&Iacute;CH &Uacute;DAJŮ</strong></p>
  <p>
    Va&scaron;e osobn&iacute; &uacute;daje můžeme sd&iacute;let s třet&iacute;mi stranami v
    n&aacute;sleduj&iacute;c&iacute;ch př&iacute;padech:
  </p>
  <ul>
    <li>
      <strong>Poskytovatel&eacute; služeb AML a KYC</strong> (kontrola pran&iacute;
      &scaron;pinav&yacute;ch peněz a ověřov&aacute;n&iacute; identity),
    </li>
    <li>
      <strong
        >Banky, finančn&iacute; instituce a poskytovatel&eacute; platebn&iacute;ch služeb</strong
      >
      za &uacute;čelem nahr&aacute;n&iacute; finančn&iacute;ch prostředků, prov&aacute;děn&iacute;
      platebn&iacute;ch transakc&iacute; a přij&iacute;m&aacute;n&iacute; finančn&iacute;ch
      prostředků; tito poskytovatel&eacute; zahrnuj&iacute; banky, poskytovatele platebn&iacute;ch
      služeb, akceptačn&iacute; instituce, alternativn&iacute; poskytovatele plateb a poskytovatele
      služeb informac&iacute; o &uacute;čtu,
    </li>
    <li>
      <strong
        >Třet&iacute; strany, jako jsou banky, finančn&iacute; instituce a poskytovatel&eacute;
        platebn&iacute;ch služeb</strong
      >, pokud jsme povinni zveřejnit va&scaron;e &uacute;daje (včetně KYC &uacute;dajů, DD
      &uacute;dajů, &uacute;dajů o prověřov&aacute;n&iacute; a monitorov&aacute;n&iacute;
      transakc&iacute;) pro splněn&iacute; regulačn&iacute;ch povinnost&iacute; nebo
      posouzen&iacute; rizik,
    </li>
    <li>
      <strong>Třet&iacute; strany poskytuj&iacute;c&iacute; služby</strong> umožňuj&iacute;c&iacute;
      n&aacute;m provozovat na&scaron;i činnost, včetně:
    </li>
    <ul>
      <li>IT a hostingov&yacute;ch poskytovatelů,</li>
      <li>poskytovatelů cloudov&eacute;ho &uacute;loži&scaron;tě,</li>
      <li>e-mailov&yacute;ch platforem,</li>
      <li>syst&eacute;mů pro spr&aacute;vu kontaktů a z&aacute;kaznick&eacute; podpory,</li>
      <li>
        poskytovatelů služeb prověřov&aacute;n&iacute; a monitorov&aacute;n&iacute;
        transakc&iacute;,
      </li>
      <li>
        &uacute;věrov&yacute;ch agentur (za &uacute;čelem prověřen&iacute; bonity a/nebo
        ověřen&iacute; identity),
      </li>
      <li>poskytovatelů monitorov&aacute;n&iacute; URL adres,</li>
      <li>marketingov&yacute;ch společnost&iacute;,</li>
      <li>poskytovatelů notifikac&iacute; a komunikace,</li>
    </ul>
    <li>
      <strong>Agentury pro prevenci podvodů</strong>, pokud jsme povinni sd&iacute;let osobn&iacute;
      &uacute;daje za &uacute;čelem splněn&iacute; pr&aacute;vn&iacute;ch nebo regulačn&iacute;ch
      povinnost&iacute; nebo k prevenci a/nebo odhalov&aacute;n&iacute; finančn&iacute; kriminality
      či jin&yacute;ch nez&aacute;konn&yacute;ch aktivit,
    </li>
    <li>
      <strong
        >Př&iacute;slu&scaron;n&eacute; org&aacute;ny činn&eacute; v trestn&iacute;m
        ř&iacute;zen&iacute;, regulačn&iacute; a vl&aacute;dn&iacute; org&aacute;ny, soudy nebo
        jin&eacute; třet&iacute; strany</strong
      >, jako jsou policie, dozorov&eacute; org&aacute;ny, daňov&eacute; a soci&aacute;ln&iacute;
      zabezpečovac&iacute; &uacute;řady, pokud se domn&iacute;v&aacute;me, že zveřejněn&iacute; je
      nezbytn&eacute;:
    </li>
    <ul>
      <li>(i) z důvodu platn&eacute;ho z&aacute;kona nebo nař&iacute;zen&iacute;, nebo</li>
      <li>
        (ii) k uplatněn&iacute;, stanoven&iacute; nebo obraně na&scaron;ich pr&aacute;vn&iacute;ch
        n&aacute;roků,
      </li>
    </ul>
    <li>
      <strong>Dal&scaron;&iacute; třet&iacute; strany</strong>, jako je policie nebo dozorov&eacute;
      org&aacute;ny, v reakci na ž&aacute;dosti o sd&iacute;len&iacute; &uacute;dajů. V těchto
      př&iacute;padech sd&iacute;l&iacute;me osobn&iacute; &uacute;daje pouze tehdy, pokud jsme
      přesvědčeni, že to pr&aacute;vn&iacute; předpisy umožňuj&iacute; a sd&iacute;len&iacute;
      &uacute;dajů je opr&aacute;vněn&eacute;,
    </li>
    <li>
      <strong
        >Třet&iacute; strany v př&iacute;padě f&uacute;ze, prodeje nebo převodu č&aacute;sti
        na&scaron;eho podnik&aacute;n&iacute; či aktiv</strong
      >, přičemž mus&iacute; existovat př&iacute;sn&aacute; povinnost mlčenlivosti,
    </li>
    <li>
      <strong
        >Auditoři, poradci, &uacute;četn&iacute;, pr&aacute;vn&iacute; z&aacute;stupci a
        podobn&iacute; zprostředkovatel&eacute;</strong
      >, kteř&iacute; n&aacute;m poskytuj&iacute; poradensk&eacute; služby pro legitimn&iacute;
      obchodn&iacute; &uacute;čely, přičemž smluvně nesm&iacute; osobn&iacute; &uacute;daje
      použ&iacute;t k ž&aacute;dn&eacute;mu jin&eacute;mu &uacute;čelu; v těchto př&iacute;padech
      rovněž plat&iacute; př&iacute;sn&aacute; povinnost mlčenlivosti,
    </li>
    <li>
      <strong>S va&scaron;&iacute;m souhlasem</strong> mohou b&yacute;t va&scaron;e &uacute;daje
      použity i k dal&scaron;&iacute;m &uacute;čelům, pro kter&eacute; poskytnete
      v&yacute;slovn&yacute; souhlas.
    </li>
  </ul>
  <p><strong>UCHOV&Aacute;V&Aacute;N&Iacute; OSOBN&Iacute;CH &Uacute;DAJŮ</strong></p>
  <p>
    N&aacute;&scaron; web, aplikace, syst&eacute;m a poskytovatel&eacute; cloudov&yacute;ch
    &uacute;loži&scaron;ť uchov&aacute;vaj&iacute; osobn&iacute; &uacute;daje v r&aacute;mci EU a
    EHP, takže va&scaron;e informace jsou obecně ukl&aacute;d&aacute;ny v t&eacute;to oblasti.
  </p>
  <p>
    Pokud je nutn&eacute; přev&eacute;st va&scaron;e osobn&iacute; &uacute;daje do jin&yacute;ch
    zem&iacute; za &uacute;čelem poskytov&aacute;n&iacute; na&scaron;ich služeb, zavazujeme se
    zajistit, že budou přijata ve&scaron;ker&aacute; nezbytn&aacute; ochrann&aacute; opatřen&iacute;
    a že budou před přenosem va&scaron;ich &uacute;dajů provedeny př&iacute;slu&scaron;n&eacute;
    anal&yacute;zy. <strong>Draph</strong> zejm&eacute;na použ&iacute;v&aacute; standardn&iacute;
    smluvn&iacute; doložky EU a specifick&eacute; doložky podle jednotliv&yacute;ch zem&iacute;,
    pokud je to relevantn&iacute;.
  </p>
  <p><strong>DOBA UCHOV&Aacute;N&Iacute; OSOBN&Iacute;CH &Uacute;DAJŮ</strong></p>
  <p>
    Va&scaron;e osobn&iacute; &uacute;daje budeme uchov&aacute;vat pouze po dobu, kter&aacute; je
    <strong>rozumně nezbytn&aacute;</strong>, minim&aacute;lně v&scaron;ak
    <strong>po dobu 5 (pěti) let</strong>, abychom splnili &uacute;čely, pro kter&eacute; byly
    &uacute;daje shrom&aacute;žděny, včetně splněn&iacute; pr&aacute;vn&iacute;ch a
    regulačn&iacute;ch povinnost&iacute; (včetně předpisů o prevenci pran&iacute;
    &scaron;pinav&yacute;ch peněz a financov&aacute;n&iacute; terorismu &ndash; AML/CTF),
    daňov&yacute;ch, &uacute;četn&iacute;ch či evidenčn&iacute;ch požadavků. Va&scaron;e
    osobn&iacute; &uacute;daje můžeme uchov&aacute;vat i d&eacute;le, pokud n&aacute;m to
    ukl&aacute;daj&iacute; platn&eacute; regulačn&iacute; požadavky, v př&iacute;padě
    st&iacute;žnosti nebo pokud se domn&iacute;v&aacute;me, že může doj&iacute;t k
    pr&aacute;vn&iacute;mu sporu t&yacute;kaj&iacute;c&iacute;mu se na&scaron;eho vztahu s
    v&aacute;mi.
  </p>
  <p>
    Při určov&aacute;n&iacute; vhodn&eacute; doby uchov&aacute;n&iacute; osobn&iacute;ch
    &uacute;dajů bereme v &uacute;vahu:
  </p>
  <ul>
    <li>
      požadavky
      <strong
        >z&aacute;kona č. 110/2019 Sb. o zpracov&aacute;n&iacute; osobn&iacute;ch
        &uacute;dajů</strong
      >
      (ZZO&Uacute;),
    </li>
    <li>
      <strong>GDPR</strong> a platn&eacute; n&aacute;rodn&iacute; z&aacute;kony a předpisy
      <strong>AML/CTF</strong>,
    </li>
    <li>dobu trv&aacute;n&iacute; obchodn&iacute;ho vztahu,</li>
    <li>objem, povahu a citlivost osobn&iacute;ch &uacute;dajů,</li>
    <li>
      potenci&aacute;ln&iacute; riziko neopr&aacute;vněn&eacute;ho použit&iacute; nebo
      zpř&iacute;stupněn&iacute; va&scaron;ich osobn&iacute;ch &uacute;dajů,
    </li>
    <li>
      &uacute;čely, pro kter&eacute; &uacute;daje zpracov&aacute;v&aacute;me, a zda jich lze
      dos&aacute;hnout jin&yacute;mi prostředky,
    </li>
    <li>
      platn&eacute; pr&aacute;vn&iacute;, regulačn&iacute;, daňov&eacute;, &uacute;četn&iacute; nebo
      jin&eacute; požadavky.
    </li>
  </ul>
  <p>
    Pro dal&scaron;&iacute; informace o době uchov&aacute;n&iacute; va&scaron;ich &uacute;dajů
    n&aacute;s můžete kdykoli kontaktovat prostřednictv&iacute;m n&iacute;že uveden&yacute;ch
    kontaktn&iacute;ch &uacute;dajů.
  </p>
  <p>
    Obecně uchov&aacute;v&aacute;me osobn&iacute; &uacute;daje, dokud nejsou splněny &uacute;čely
    jejich zpracov&aacute;n&iacute;,
    <strong
      >pokud neexistuj&iacute; z&aacute;konn&eacute; povinnosti jejich
      uchov&aacute;n&iacute;</strong
    >
    (např. m&iacute;stn&iacute; z&aacute;kony o boji proti pran&iacute; &scaron;pinav&yacute;ch
    peněz, obchodn&iacute; nebo daňov&eacute; předpisy).
  </p>
  <p>
    V určit&yacute;ch př&iacute;padech můžete pož&aacute;dat o
    <strong>vymaz&aacute;n&iacute; va&scaron;ich &uacute;dajů</strong>. V jin&yacute;ch
    př&iacute;padech můžeme va&scaron;e osobn&iacute; &uacute;daje
    <strong>anonymizovat</strong> (tak, aby v&aacute;s již nebylo možn&eacute; identifikovat) pro
    v&yacute;zkumn&eacute; nebo statistick&eacute; &uacute;čely, v takov&eacute;m př&iacute;padě
    můžeme tyto &uacute;daje použ&iacute;vat neomezeně bez dal&scaron;&iacute;ho upozorněn&iacute;.
  </p>
  <p><strong>VA&Scaron;E PR&Aacute;VA</strong></p>
  <p>
    Podle z&aacute;kona <strong>ZZO&Uacute; a GDPR</strong> m&aacute;te řadu pr&aacute;v
    t&yacute;kaj&iacute;c&iacute;ch se va&scaron;ich osobn&iacute;ch &uacute;dajů. Tato pr&aacute;va
    a způsob, jak je můžete uplatnit, jsou uvedeny n&iacute;že.
  </p>
  <p>
    Před odpověd&iacute; na ž&aacute;dost o uplatněn&iacute; těchto pr&aacute;v od v&aacute;s můžeme
    vyžadovat <strong>důkaz totožnosti</strong> a př&iacute;padně dal&scaron;&iacute; informace,
    kter&eacute; n&aacute;m pomohou lokalizovat osobn&iacute; &uacute;daje souvisej&iacute;c&iacute;
    s va&scaron;&iacute; ž&aacute;dost&iacute;.
  </p>
  <p>
    Pokud chcete uplatnit někter&eacute; z těchto pr&aacute;v nebo potřebujete dal&scaron;&iacute;
    informace, kontaktujte n&aacute;s prostřednictv&iacute;m n&iacute;že uveden&yacute;ch
    kontaktn&iacute;ch &uacute;dajů.
  </p>
  <ul>
    <li>
      <strong>Pr&aacute;vo na př&iacute;stup k va&scaron;im &uacute;dajům</strong> &ndash; Můžete
      n&aacute;s pož&aacute;dat o kopii v&scaron;ech osobn&iacute;ch &uacute;dajů, kter&eacute; o
      v&aacute;s uchov&aacute;v&aacute;me (s v&yacute;jimkami stanoven&yacute;mi z&aacute;konem).
    </li>
    <li>
      <strong
        >Pr&aacute;vo vzn&eacute;st n&aacute;mitku proti zpracov&aacute;n&iacute; va&scaron;ich
        &uacute;dajů</strong
      >
      &ndash; Pokud va&scaron;e &uacute;daje zpracov&aacute;v&aacute;me na z&aacute;kladě
      <strong>opr&aacute;vněn&eacute;ho z&aacute;jmu</strong>, m&aacute;te pr&aacute;vo
      vzn&eacute;st n&aacute;mitku. Pokud v&scaron;ak prok&aacute;žeme
      <strong>z&aacute;važn&eacute; opr&aacute;vněn&eacute; důvody</strong> pro
      zpracov&aacute;n&iacute;, můžeme ve zpracov&aacute;n&iacute; pokračovat.
    </li>
    <li>
      <strong>Pr&aacute;vo odm&iacute;tnout marketingov&aacute; sdělen&iacute;</strong> &ndash;
      Můžete n&aacute;s pož&aacute;dat, abychom v&aacute;m nezas&iacute;lali př&iacute;m&yacute;
      marketing. Odhl&aacute;sit se můžete pomoc&iacute;
      <strong>odkazu &bdquo;odhl&aacute;sit odběr&ldquo;</strong> v marketingov&yacute;ch e-mailech.
    </li>
    <li>
      <strong>Pr&aacute;vo na opravu nepřesn&yacute;ch &uacute;dajů</strong> &ndash; Pokud
      zjist&iacute;te, že va&scaron;e &uacute;daje jsou nepřesn&eacute; nebo ne&uacute;pln&eacute;,
      můžete pož&aacute;dat o jejich <strong>opravu</strong>. Pokud ověř&iacute;me spr&aacute;vnost
      nov&yacute;ch &uacute;dajů, provedeme opravu co nejdř&iacute;ve.
    </li>
    <li>
      <strong
        >Pr&aacute;vo na vymaz&aacute;n&iacute; &uacute;dajů (&bdquo;pr&aacute;vo b&yacute;t
        zapomenut&ldquo;) &ndash;</strong
      >
      Můžete pož&aacute;dat o
      <strong>smaz&aacute;n&iacute; va&scaron;ich osobn&iacute;ch &uacute;dajů</strong> v
      určit&yacute;ch situac&iacute;ch, např&iacute;klad pokud byly zpracov&aacute;ny
      <strong>neopr&aacute;vněně</strong> nebo je již nepotřebujeme pro &uacute;čely uveden&eacute;
      v těchto z&aacute;sad&aacute;ch.
    </li>
    <li>
      <strong>Pr&aacute;vo na omezen&iacute; zpracov&aacute;n&iacute;</strong> &ndash; Můžete
      n&aacute;s pož&aacute;dat o
      <strong>omezen&iacute; zpracov&aacute;n&iacute;</strong> va&scaron;ich &uacute;dajů v
      někter&yacute;ch situac&iacute;ch, např&iacute;klad pokud se domn&iacute;v&aacute;te, že
      &uacute;daje nejsou přesn&eacute; a potřebujeme je ověřit, nebo pokud už &uacute;daje
      nepotřebujeme, ale vy je vyžadujete k uplatněn&iacute; sv&yacute;ch
      <strong>pr&aacute;vn&iacute;ch n&aacute;roků</strong>. V takov&eacute;m př&iacute;padě můžeme
      &uacute;daje pouze uchov&aacute;vat, ale nesm&iacute;me je d&aacute;le zpracov&aacute;vat,
      pokud k tomu nem&aacute;te souhlas nebo pokud to nen&iacute; nezbytn&eacute; pro
      pr&aacute;vn&iacute; n&aacute;roky nebo ochranu jin&yacute;ch osob.
    </li>
    <li>
      <strong>Pr&aacute;vo odvolat souhlas se zpracov&aacute;n&iacute;m &uacute;dajů</strong>
      &ndash; Pokud va&scaron;e &uacute;daje zpracov&aacute;v&aacute;me na z&aacute;kladě
      <strong>souhlasu</strong>, m&aacute;te pr&aacute;vo svůj souhlas kdykoli
      <strong>odvolat</strong>.
    </li>
    <li>
      <strong
        >Pr&aacute;vo určit, jak budou va&scaron;e &uacute;daje zpracov&aacute;v&aacute;ny po
        va&scaron;&iacute; smrti</strong
      >
      &ndash; Můžete určit pokyny, jak by měly b&yacute;t va&scaron;e osobn&iacute; &uacute;daje
      zpracov&aacute;v&aacute;ny po va&scaron;&iacute; smrti.
    </li>
  </ul>
  <ul>
    <li><strong>COOKIES</strong></li>
    <li>
      Cookie je mal&yacute; datov&yacute; soubor (textov&yacute; soubor), kter&yacute; webov&aacute;
      str&aacute;nka nebo aplikace &ndash; při n&aacute;v&scaron;těvě uživatelem &ndash;
      pož&aacute;d&aacute; v&aacute;&scaron; prohl&iacute;žeč o uložen&iacute; do va&scaron;eho
      zař&iacute;zen&iacute;, aby si zapamatovala informace o v&aacute;s, např&iacute;klad
      va&scaron;e jazykov&eacute; preference nebo přihla&scaron;ovac&iacute; &uacute;daje. Tyto
      cookies jsou nastaveny n&aacute;mi a naz&yacute;vaj&iacute; se
      <strong>cookies prvn&iacute; strany</strong>. Použ&iacute;v&aacute;me tak&eacute;
      <strong>cookies třet&iacute;ch stran</strong> &ndash; tedy cookies z dom&eacute;ny
      odli&scaron;n&eacute; od dom&eacute;ny webu nebo aplikace, kterou nav&scaron;těvujete &ndash;
      pro na&scaron;e reklamn&iacute; a marketingov&eacute; &uacute;čely.
    </li>
    <li>
      Konkr&eacute;tně použ&iacute;v&aacute;me cookies a dal&scaron;&iacute; sledovac&iacute;
      technologie k n&aacute;sleduj&iacute;c&iacute;m &uacute;čelům:
    </li>
    <li><strong>V&yacute;konnostn&iacute; cookies</strong></li>
    <li>
      Tyto cookies n&aacute;m umožňuj&iacute; poč&iacute;tat n&aacute;v&scaron;těvy a zdroje
      provozu, abychom mohli měřit a zlep&scaron;ovat v&yacute;kon na&scaron;eho webu a aplikace.
      Pom&aacute;haj&iacute; n&aacute;m zjistit, kter&eacute; str&aacute;nky jsou
      nejnav&scaron;těvovaněj&scaron;&iacute; a nejm&eacute;ně popul&aacute;rn&iacute;, a sledovat,
      jak se n&aacute;v&scaron;těvn&iacute;ci pohybuj&iacute; po webu a aplikaci. V&scaron;echny
      informace, kter&eacute; tyto cookies shromažďuj&iacute;, jsou agregovan&eacute; a tedy
      anonymn&iacute;. Pokud tyto cookies nepovol&iacute;te, nebudeme vědět, kdy jste
      n&aacute;&scaron; web a aplikaci nav&scaron;t&iacute;vili, a nebudeme schopni sledovat jejich
      v&yacute;kon.
    </li>
    <li><strong>Funkčn&iacute; cookies</strong></li>
    <li>
      Tyto cookies umožňuj&iacute; webov&eacute; str&aacute;nce poskytovat
      roz&scaron;&iacute;řen&eacute; funkce a personalizaci. Mohou b&yacute;t nastaveny n&aacute;mi
      nebo poskytovateli třet&iacute;ch stran, jejichž služby jsme přidali na na&scaron;e
      str&aacute;nky. Pokud tyto cookies nepovol&iacute;te, někter&eacute; nebo v&scaron;echny tyto
      služby nemus&iacute; fungovat spr&aacute;vně.
    </li>
    <li><strong>C&iacute;len&eacute; (reklamn&iacute;) cookies</strong></li>
    <li>
      Tyto cookies mohou b&yacute;t nastaveny na&scaron;&iacute; webovou str&aacute;nkou a
      aplikac&iacute; na&scaron;imi reklamn&iacute;mi partnery. Tyto společnosti je mohou
      použ&iacute;t k vytvořen&iacute; profilu va&scaron;ich z&aacute;jmů a
      zobrazov&aacute;n&iacute; relevantn&iacute;ch reklam na jin&yacute;ch webech.
      Neuchov&aacute;vaj&iacute; př&iacute;mo osobn&iacute; &uacute;daje, ale jsou založeny na
      jedinečn&eacute; identifikaci va&scaron;eho prohl&iacute;žeče a internetov&eacute;ho
      zař&iacute;zen&iacute;. Pokud tyto cookies nepovol&iacute;te, zažijete m&eacute;ně
      c&iacute;lenou reklamu.
    </li>
    <li><strong>Striktně nezbytn&eacute; cookies</strong></li>
    <li>
      Tyto cookies jsou nezbytn&eacute; pro fungov&aacute;n&iacute; webov&eacute; str&aacute;nky a
      aplikace a nelze je v na&scaron;em syst&eacute;mu vypnout. Obvykle jsou nastaveny pouze v
      reakci na va&scaron;e akce, kter&eacute; odpov&iacute;daj&iacute; požadavku na služby,
      např&iacute;klad nastaven&iacute; va&scaron;ich preferenc&iacute; ochrany soukrom&iacute;,
      přihl&aacute;&scaron;en&iacute; nebo vyplňov&aacute;n&iacute; formul&aacute;řů. Svůj
      prohl&iacute;žeč můžete nastavit tak, aby tyto cookies blokoval nebo v&aacute;s na ně
      upozorňoval, ale někter&eacute; č&aacute;sti webu pak nebudou fungovat. Tyto cookies
      neuchov&aacute;vaj&iacute; ž&aacute;dn&eacute; osobn&iacute; identifikačn&iacute;
      &uacute;daje.
    </li>
    <li>
      Cookies nemus&iacute; obsahovat ž&aacute;dn&eacute; informace, kter&eacute; by př&iacute;mo
      identifikovaly uživatele, ale osobn&iacute; &uacute;daje, kter&eacute; o v&aacute;s
      uchov&aacute;v&aacute;me, mohou b&yacute;t propojeny s informacemi uložen&yacute;mi v cookies
      a z&iacute;skan&yacute;mi z nich.
    </li>
    <li>
      Upozorňujeme, že třet&iacute; strany (např&iacute;klad reklamn&iacute; s&iacute;tě a
      poskytovatel&eacute; extern&iacute;ch služeb, jako jsou služby anal&yacute;zy webov&eacute;ho
      provozu) mohou tak&eacute; použ&iacute;vat cookies, nad kter&yacute;mi nem&aacute;me kontrolu.
      Tyto cookies pravděpodobně patř&iacute; mezi analytick&eacute;/v&yacute;konnostn&iacute; nebo
      c&iacute;len&eacute; cookies.
    </li>
    <li><strong>Spr&aacute;va cookies</strong></li>
    <li>
      Svou preferenci t&yacute;kaj&iacute;c&iacute; se použ&iacute;v&aacute;n&iacute; cookies na
      na&scaron;em webu a v na&scaron;&iacute; aplikaci můžete spravovat v n&iacute;že
      uveden&yacute;ch nastaven&iacute;ch. Vět&scaron;ina prohl&iacute;žečů umožňuje
      odm&iacute;tnout přij&iacute;m&aacute;n&iacute; cookies a mazat cookies. Metody se
      li&scaron;&iacute; podle prohl&iacute;žeče a jeho verze. Blokov&aacute;n&iacute; v&scaron;ech
      cookies bude m&iacute;t negativn&iacute; dopad na použitelnost mnoha webov&yacute;ch
      str&aacute;nek. Pokud cookies zablokujete, nebudete moci využ&iacute;vat v&scaron;echny funkce
      na&scaron;eho webu a aplikace.
    </li>
    <li></li>
    <li><strong>WEBOV&Aacute; STR&Aacute;NKA A APLIKACE</strong></li>
    <li>
      Jsme vlastn&iacute;kem nebo držitelem licence ke v&scaron;em pr&aacute;vům
      du&scaron;evn&iacute;ho vlastnictv&iacute; na na&scaron;&iacute; webov&eacute; str&aacute;nce
      a aplikaci a k obsahu, kter&yacute; je na nich zveřejněn. Tyto pr&aacute;ce jsou
      chr&aacute;něny autorsk&yacute;mi z&aacute;kony a mezin&aacute;rodn&iacute;mi dohodami o
      autorsk&yacute;ch pr&aacute;vech. V&scaron;echna takov&aacute; pr&aacute;va jsou vyhrazena.
    </li>
    <li>
      Můžete si vytisknout jednu kopii nebo st&aacute;hnout v&yacute;ňatky jak&eacute;koli
      str&aacute;nky z na&scaron;&iacute; webov&eacute; str&aacute;nky a aplikace pro svou
      osobn&iacute; potřebu a můžete upozornit ostatn&iacute; ve sv&eacute; organizaci na obsah
      zveřejněn&yacute; na na&scaron;&iacute; webov&eacute; str&aacute;nce a aplikaci.
      Nesm&iacute;te ž&aacute;dn&yacute;m způsobem upravovat pap&iacute;rov&eacute; nebo
      digit&aacute;ln&iacute; kopie jak&yacute;chkoli materi&aacute;lů, kter&eacute; jste si
      vytiskli nebo st&aacute;hli, a nesm&iacute;te použ&iacute;vat ž&aacute;dn&eacute; ilustrace,
      fotografie, video či zvukov&eacute; sekvence nebo jakoukoliv grafiku odděleně od
      doprovodn&eacute;ho textu.
    </li>
    <li>
      Nesm&iacute;te použ&iacute;vat ž&aacute;dnou č&aacute;st obsahu na&scaron;&iacute;
      webov&eacute; str&aacute;nky a aplikace pro komerčn&iacute; &uacute;čely bez
      z&iacute;sk&aacute;n&iacute; licence od n&aacute;s nebo na&scaron;ich poskytovatelů
      licenc&iacute;. Pokud vytisknete, zkop&iacute;rujete nebo st&aacute;hnete jakoukoli
      č&aacute;st na&scaron;&iacute; webov&eacute; str&aacute;nky nebo aplikace v rozporu s těmito
      podm&iacute;nkami, va&scaron;e pr&aacute;vo na jejich použ&iacute;v&aacute;n&iacute; okamžitě
      zanikne a na na&scaron;i v&yacute;zvu mus&iacute;te vr&aacute;tit nebo zničit jak&eacute;koli
      kopie materi&aacute;lů, kter&eacute; jste vytvořili.
    </li>
    <li>
      Můžeme na&scaron;i webovou str&aacute;nku a aplikaci čas od času aktualizovat a měnit, aby
      odr&aacute;žely změny na&scaron;ich služeb, potřeb klientů a na&scaron;ich obchodn&iacute;ch
      priorit.
    </li>
    <li></li>
    <li><strong>KONTAKTOV&Aacute;N&Iacute; N&Aacute;S</strong></li>
    <li>
      Pokud m&aacute;te jak&eacute;koli dotazy nebo obavy ohledně těchto Z&aacute;sad ochrany
      osobn&iacute;ch &uacute;dajů a/nebo na&scaron;eho zpracov&aacute;n&iacute; va&scaron;ich
      osobn&iacute;ch &uacute;dajů, můžete n&aacute;s kontaktovat prostřednictv&iacute;m
      kontaktn&iacute;ho formul&aacute;ře na na&scaron;em webu nebo e-mailem na adresu:
      <strong>support@swipez.eu</strong>.
    </li>
    <li>
      Pokud v&aacute;&scaron; probl&eacute;m nelze vyře&scaron;it prostřednictv&iacute;m
      na&scaron;eho t&yacute;mu z&aacute;kaznick&eacute; podpory, můžete podat st&iacute;žnost dle
      postupu uveden&eacute;ho v na&scaron;em
      <strong>Reklamačn&iacute;m ř&aacute;du</strong> dostupn&eacute;m na na&scaron;em webu.
    </li>
    <li></li>
    <li><strong>Změny z&aacute;sad ochrany osobn&iacute;ch &uacute;dajů</strong></li>
    <li>
      Tyto z&aacute;sady můžeme čas od času aktualizovat. Jak&eacute;koli změny, kter&eacute;
      provedeme, budou zveřejněny na t&eacute;to str&aacute;nce. O v&yacute;znamn&yacute;ch
      změn&aacute;ch v&aacute;s můžeme informovat e-mailem nebo prostřednictv&iacute;m
      syst&eacute;mu.
    </li>
    <li><strong>Posledn&iacute; aktualizace: 01.10.2024</strong></li>
  </ul>
</template>
